import { setPersonalEmailWarningModal } from '../../store/signUp/slice';
import { EmailSquareIcon } from '../../assets/icons';
import { useDispatch } from '../../store/store';
import Button from '../../components/Button';
import Modal from '../../components/Modal';
import styles from './style.module.scss';

export default function PersonalEmailWarning() {
    const dispatch = useDispatch();

    const dismissFunc = () => {
        dispatch(setPersonalEmailWarningModal(false));
    };

    return (
        <Modal
            size='sm'
            closeFunc={dismissFunc}
            icon={<EmailSquareIcon />}
            childClassName={styles.wrapper}
            title='Personal email whitelisting'
        >
            <span className={styles.text}>
                Registration with personal email addresses is not allowed.
            </span>
            <p className={styles.description}>
                Use the email address associated with your workplace or
                organization to ensure your registration is properly considered.
            </p>
            <div className={styles.actions}>
                <Button
                    text='Cancel'
                    type='Outline-Dark'
                    onClick={dismissFunc}
                    className={styles.actions_btn}
                />
                <Button
                    type='Primary'
                    text='Continue'
                    onClick={dismissFunc}
                    className={styles.actions_btn}
                />
            </div>
        </Modal>
    )
}
